import { markets } from '../constants';
import { IAppState, IAppStateControlProperty } from '../types';

/** @private */
function getObjectToMap(parentNames: string[], object: any) {
    if (parentNames?.length) {
        return parentNames.reduce((nestedObject, key, i, array) => {
            if (!nestedObject[key]) {
                // eslint-disable-next-line no-param-reassign
                nestedObject[key] = Number.isNaN(parseInt(array[i + 1], 10)) ? {} : [];
            }

            return nestedObject[key];
        }, object);
    }

    return object;
}

/** @private */
function controlsToPlainObject(controls: IAppStateControlProperty) {
    return Object.keys(controls).reduce((dest, key) => {
        const { disabled, parentProps, controlInstances, value: controlValue } = controls[key];

        if (disabled || (parentProps && parentProps.disabled) || controlInstances) {
            return dest;
        }

        const keys = key.split('.');
        const controlName = keys.pop() ?? '';
        const objectToMap = getObjectToMap(keys, dest);
        objectToMap[controlName] = controlValue === '' ? undefined : controlValue;

        return dest;
    }, {} as any);
}

/** @private */
function futureIncomeToIncome(controlsState: IAppStateControlProperty, market: string) {
    if (market !== markets.lithuania) return controlsState;
    if (!controlsState['applicant.employment.income']?.value) return controlsState;
    if (!controlsState['futureIncome']?.value) return controlsState;
    controlsState['applicant.employment.income'].value = controlsState['futureIncome'].value;
    return controlsState as IAppStateControlProperty;
}

export function prepareFormDataForSubmit({ controlsState, formMeta }: IAppState) {
    return {
        ...controlsToPlainObject(futureIncomeToIncome(controlsState, formMeta.market)),
        formMeta,
    };
}
